export default __webpack_public_path__ + "static/media/bundle-coach-aok-northwest@1x.06d82360.jpg";